import React from 'react';

import { pluralize } from 'utilities/pluralize';

import Card from '@marketing/components/card';
import SectionHeader from '@marketing/components/section_header';

import Arrow from './assets/arrow.png';
import BubbleCheckIcon from './assets/bubble_check_icon.svg';
import CheckCircleIcon from './assets/check_circle_icon.svg';
import MagooshLogo from '@magoosh/assets/magoosh-logo-purple.png';
import TimesCircleIcon from './assets/times_circle_icon.svg';

interface Props {
  competitorShortfalls: (string | React.ReactNode)[];
  magooshFeatures: (string | React.ReactNode)[];
  pointIncrease?: number;
  title?: string
}
export default (props: Props) => {
  return (
    <div className="d-flex flex-column gap-l">

      <SectionHeader
        reveal
        subtitle={`Improve your score${props.pointIncrease ? `by ${pluralize(props.pointIncrease, 'point')}` : ''} or your money back.`}
        supertitle="We offer more"
        supertitleIcon={BubbleCheckIcon}
        title={props.title || 'Better scores. Better price. Guaranteed.'}
      >
        <SectionHeader.Left>
          <div className="d-flex hidden-xs hidden-sm justify-content-end" style={{ flex: '2 1 0' }}>
            <img
              alt="Arrow pointing down to Magoosh features"
              height="152px"
              src={Arrow}
              style={{ marginBottom: -80 }}
              width="191px"
            />
          </div>
        </SectionHeader.Left>
      </SectionHeader>

      <div className="align-items-lg-end d-flex flex-column flex-lg-row gap-l">
        <Card className="flex-1">
          <div><img alt="Magoosh logo" height="26px" src={MagooshLogo} width="116px" /></div>

          <div className="d-flex flex-column gap-s">
            {
              props.magooshFeatures.map((magooshFeature, idx) => (
                <MagooshFeature key={idx}>{magooshFeature}</MagooshFeature>
              ))
            }
          </div>
        </Card>

        <div className="d-flex flex-1 flex-column gap-s">
          <div style={{ color: '#8D8D8D', fontSize: 18 }}>
            <strong>Other "Premium" Courses</strong>
          </div>

          <div className="d-flex flex-column gap-s">
            {
              props.competitorShortfalls.map((competitorShortfall, idx) => {
                let skewAngle = 0;

                if (idx != props.competitorShortfalls.length - 1) {
                  skewAngle = [0.75, -1.14, 1.24, -1.48][idx % 4];
                }

                return(
                  <CompetitorShortfall key={idx} skewAngle={skewAngle}>
                    {competitorShortfall}
                  </CompetitorShortfall>
                );
              })
            }
          </div>
        </div>
      </div>
    </div>
  );
};

const CompetitorShortfall = (props) => {
  return (
    <div
      style={{
        // In order to use a border radius we need to use a different approach to a dashed
        // background. This approach only works with a white background so we can'pt use it
        // everywhere.
        background: 'linear-gradient(#fff 0 0) padding-box, linear-gradient(to bottom, #CECECE) border-box',
        border: '1px dashed #fff',
        borderRadius: 12,
        overflow: 'hidden',
        transform: props.skewAngle ? `rotate(${props.skewAngle}deg)` : 'none'
      }}
    >
      <div
        className="align-items-center d-flex gap-s"
        style={{
          background: 'linear-gradient(90deg, #F5F5F5, #FFFFFF)',
          padding: 16
        }}
      >
        <img alt="X icon" height="20px" loading="lazy" src={TimesCircleIcon} width="20px" />
        <div>{props.children}</div>
      </div>
    </div>
  );
};

const MagooshFeature = (props) => {
  return (
    <div
      className="align-items-center d-flex gap-s"
      style={{ background: '#E9F7F1', borderRadius: 12, padding: 16 }}
    >
      <img alt="Checkmark icon" height="20px" loading="lazy" src={CheckCircleIcon} width="20px" />
      <div>{props.children}</div>
    </div>
  );
};
